// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider-dotted[data-v-3fd3642c]{border-width:0;background-size:6px 3px;background-repeat:repeat-x;background-position-y:bottom;background-image:radial-gradient(circle,rgba(0,0,0,.15) .05rem,transparent 1.5px);height:3px}", ""]);
// Exports
module.exports = exports;
